enum FontType {
  NOTO_SANS = 'Noto Sans',
  NOTO_SERIF = 'Noto Serif',
}

export default FontType;
